import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-form-time-and-duration-button-enabler"
export default class extends Controller {
  static targets = ["errors", "button"]

  connect() {
    if(this.errorsTarget.innerHTML.trim() != ""){
      this.buttonTarget.classList.add("btn-disabled")
    }
  }
}
